import CellActions from "Components/CellActions";
import { capitalize } from "lodash";
import React, { useState } from "react";
import { Badge, Table } from "reactstrap";
import { PaymentDetails } from "types";
import { getStatusColor } from "utils";
import { ViewPaymentMethodModal } from "./ViewPaymentMethodModal";

interface TableProps {
  data: PaymentDetails[];
  onDeleteItemClick: (index: number) => void;
  onEditItemClick: (item: PaymentDetails, index: number) => void;
}

export const PaymentMethodsTable = ({
  data,
  onDeleteItemClick,
  onEditItemClick,
}: TableProps) => {
  const [viewModal, setViewModal] = useState<boolean>(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<any>({});
  const getPaymentIcon = (method: string) => {
    switch (method) {
      case "bank":
        return "bx bxs-bank";
      case "momo":
        return "fas fa-mobile-alt";
      case "cash":
        return "fas fa-money-bill-wave";
      default:
        return "mdi mdi-help-circle";
    }
  };

  const toggle = () => {
    setViewModal(!viewModal);
  };

  return (
    <>
      {data && data.length > 0 ? (
        <div className="mt-4 mb-4">
          <div className="table-responsive">
            <Table className="table align-middle table-nowrap">
              <thead className="table-light">
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Description</th>
                  <th scope="col">Type</th>
                  <th scope="col">Status</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item: any, index: number) => (
                  <tr key={index}>
                    <td>
                      <div className="d-flex align-items-center">
                        <h5 className="font-size-14 text-truncate mb-0">
                          {item.name}
                        </h5>
                      </div>
                    </td>
                    <td>{item.description}</td>
                    <td>
                      <div className="font-size-12">
                        <i className={`${getPaymentIcon(item.type)} me-1`}></i>
                        {capitalize(item.type)}
                      </div>
                      {/* {item.type} */}
                    </td>

                    <td>
                      <Badge
                        className={`font-size-12 badge-soft-${getStatusColor(
                          item.status
                        )}`}
                      >
                        <i
                          className="mdi mdi-circle me-1"
                          style={{ fontSize: "10px" }}
                        ></i>
                        {capitalize(item.status)}
                      </Badge>
                    </td>
                    <td>
                      <td>
                        <CellActions
                          data={item}
                          onEdit={() => {
                            onEditItemClick(item, index);
                          }}
                          onDelete={() => onDeleteItemClick(item)}
                          onView={async () => {
                            await setSelectedPaymentMethod(item);
                            toggle();
                          }}
                        />
                      </td>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      ) : (
        <div className="text-center mt-4 mb-4">
          No payment methods have been added yet.
        </div>
      )}
      <ViewPaymentMethodModal
        isOpen={viewModal}
        toggle={toggle}
        data={selectedPaymentMethod}
      />
    </>
  );
};
